import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import React from "react";
import { useHistory } from "Hooks/useRouter";
import mergeClasses from "classnames";
import useStyles from "./styles";
import { DPEmployeeProfileItem, UserStatus } from "Shared/types/EmployeeProfiles";

interface UserTableRowProps extends DPEmployeeProfileItem {
  hideColumns: string[];
}

const UserTableRow = ({
  id,
  employee,
  employeeLocation,
  partnerCanceledAt,
  providerAccounts,
  externalIds,
  employee: { usingWisely },
  hideColumns = [],
}: UserTableRowProps) => {
  const { firstName, lastName, userStatus } = employee;
  const classes = useStyles({
    partnerCanceledAt,
    userStatus: userStatus as UserStatus,
  });
  const history = useHistory();
  const { pathname, search } = history.location;

  const primaryExternalId = externalIds.find(identifier => identifier.primary);
  const payGroups = providerAccounts.items.map(providerAccount => (
    <div
      className={classes.payGroupCell}
      key={providerAccount.company.payGroup}
    >
      {providerAccount.company.payGroup}
    </div>
  ));

  const cells = [
    { fieldName: "firstName", value: firstName },
    { fieldName: "lastName", value: lastName },
    {
      fieldName: "primaryId",
      id: "primary-id",
      value: primaryExternalId ? primaryExternalId.id : "",
    },
    { fieldName: "location", className: classes.title, value: employeeLocation?.name },
    {
      fieldName: "payGroups",
      value: payGroups,
    },
    {
      fieldName: "dailyPayStatus",
      className: classes.statusCell,
      value: userStatus,
    },
    {
      className: classes.employmentStatusCell,
      fieldName: "partnerCanceledAt",
      value: partnerCanceledAt ? "Terminated" : "Employed",
    },
    {
      fieldName: "benefitType",
      value: usingWisely ? "Wisely" : "",
    },
  ].filter(({ fieldName }) => !hideColumns.includes(fieldName));

  const onClick = () => {
    history.push({
      pathname: `/users/${id}/details`,
      state: { prevPath: pathname + search },
    });
  };

  return (
    <TableRow hover className={classes.row} onClick={onClick}>
      {cells.map(({ className, fieldName, id, value }) => (
        <TableCell
          className={mergeClasses(classes.text, className)}
          id={id}
          key={fieldName}
        >
          {value}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default UserTableRow;
